module.exports = __webpack_public_path__ + "media/images/top/search/img_introduction_banner-4e0518424bc6daccee695695ad235aef.png";